import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import UserPlan from '@creditflowresearch/user-plan/UserPlan';

interface IRegionAccessControl {
  plan: UserPlanType,
  accessibleRegionsIds: string[],
}

const isUserLoggedIn = (plan: UserPlanType): boolean => {
  return !UserPlan.isUnauthorized(plan) && !UserPlan.isStarter(plan);
};

export const hasRegionAccess = (regionId: string, accessControl: IRegionAccessControl): boolean => {
  return isUserLoggedIn(accessControl.plan) && accessControl.accessibleRegionsIds.includes(regionId);
};

export type { IRegionAccessControl };
